module.exports = __webpack_public_path__ + "assets/img/team/olivier-dazel.jpg";